import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ConfirmationService, MenuItem, SelectItem } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2';
import { NavService } from '../../../../_services/_nav.service';
import { RolFuncionalitiesServices } from '../../../../_services/rol-funcionalidad.service';
import { AutenticacionService } from '../../../../_services/autenticacion.service';
import { ConstanteService } from '../../../../_services/constante.service';
import { CanalRolService } from '../../../../_services/canal-rol.service';
import { CanalRestriccionGestionEstadoService } from '../../../../_services/canal-restriccion-gestion-estado.service';
import { TerceroCargoService } from '../../../../_services/tercero-cargo.service';
import { ContactEstadosSolicitudesService } from '../../../../_services/contact-estados-solicitudes.service';
import { UsuarioComisionFreelanceService } from '../../../../_services/usuario-comision-freelance.service';
import { SolicitudService } from '../../../../_services/solicitud.service';
import { ProspectoService } from '../../../../_services/prospecto.service';
import { EstadoService } from '../../../../_services/estado.service';
import { ProductoEstadoRelacionService } from '../../../../_services/producto-estado-relacion.service';
import { ProductoEstadoRelacionCausalService } from '../../../../_services/producto-estado-relacion-causal.service';
import { EstadoCausalService } from '../../../../_services/estado-causal.service';
import { SocketConexion } from '../../../../_services/socket-conexion.service';
import { EstadoRolService } from '../../../../_services/estado-rol.service';
import { ConfiguracionesCanalesService } from '../../../../_services/configuraciones-canales.service';
import { FlujoProcesoService } from '../../../../_services/flujo-proceso.service';
import { NotificadorService } from '../../../../_services/notificador.service';
import { PerfilCrezcamosService } from '../../../../_services/perfil-crezcamos.service';
import { PerfilCrezcamosModalFirmantesComponent } from './firmantes/perfil-crezcamos-modal-firmantes.component';
import { BotonesSolicitud, Funcionalidades } from '../../../../_enums/enum';
import { ContactEstadoSolicitud } from '../../../../_models/contact-estado-solicitud';
import { UsuarioComisionFreelance } from '../../../../_models/usuario-comision-freelance';
import { EstadoRol } from '../../../../_models/estado-rol';
import { Estado } from '../../../../_models/estado';
import { Constante } from '../../../../_models/constante';
import { ConfiguracionesCanales } from '../../../../_models/configuraciones-canales';
import { Router } from '@angular/router';

@Component({
  selector: 'app-perfil-crezcamos-solicitudes-vigentes',
  templateUrl: './perfil-crezcamos-solicitudes-vigentes.component.html',
  styleUrls: ['./perfil-crezcamos-solicitudes-vigentes.component.scss']
})
export class PerfilCrezcamosSolicitudesVigentesComponent implements OnInit {
  @Input() informacionPerfil: any;
  columnasSolicitudes: any[];
  listSolicitudes: any[];
  idRegistroCargandoItems = null;
  lisItems: MenuItem[] = [];
  libranza: boolean;
  copiarUrl: string = "";
  mostrarDialogo: boolean = false;
  rolUsuario: string[] = [];
  constanteAPBDES: Constante;
  verFlujo = true;
  buscando: boolean;
  lisCentroLlamadaEstados: ContactEstadoSolicitud[] = [];
  usuarioComisionFreelance: UsuarioComisionFreelance;
  validandoIndicador: boolean = false;
  estDenegado: Estado;
  estCancelado: Estado;
  estBloqueado: Estado;
  datCambioEstado = {
    idEstado: null,
    idFase: null,
    tipo: null,
    titulo: null,
    verCausal: false,
    idSolicitud: null,
    valZona: false,
    mensajeGuardado: null
  };
  cambioEstado = {
    mosModal: false,
    guardando: false,
    submitted: false,
    lisCausales: [] as SelectItem[],
    mosModalProceso: false,
    formEstados: null
  };
  lisSolicitudSocket: any[] = [];
  lisConfiguracionCanalEstados: ConfiguracionesCanales[] = [];
  estRoles: EstadoRol[] = [];
  consultarAprobacion: any;
  carInformacionInicial: boolean = true;
  banMensaje: boolean = false;
  dataSolicitudes: any;
  permisos = { escuchar: false, gestionarFlujo: false, bloquear: false, alivio: false, verFreelance: false, comite: false, linkRetoma: false, sarlaftGestionDocumental: false, sarlaftGestionRiesgo: false };

  private navServicio = inject( NavService );
  private rolFuncionalidadService = inject( RolFuncionalitiesServices );
  private autServicio = inject( AutenticacionService );
  private conConstanteServicio = inject( ConstanteService );
  private canRolServicio = inject( CanalRolService );
  private canalRestriccionGestionEstadoService = inject( CanalRestriccionGestionEstadoService );
  private router = inject( Router );
  private terCargosServicio = inject( TerceroCargoService );
  private cenLlamadaEstadoServicio = inject( ContactEstadosSolicitudesService );
  private usuarioComisionFreelanceService = inject( UsuarioComisionFreelanceService );
  private solServicio = inject( SolicitudService );
  private conServicio = inject( ConfirmationService );
  private proServicio = inject( ProspectoService );
  private estServicio = inject( EstadoService );
  private proEstadoRelacionServicio = inject( ProductoEstadoRelacionService );
  private proEstadoRelacionCausalServicio = inject( ProductoEstadoRelacionCausalService );
  private estCausalService = inject( EstadoCausalService );
  private translateService = inject( TranslateService );
  private estRolesServicio = inject( EstadoRolService );
  private conCanalEstadoServicio = inject( ConfiguracionesCanalesService );
  private fb = inject( FormBuilder );
  private fluProcesoService = inject( FlujoProcesoService );
  private notificadorService = inject( NotificadorService );
  private perfilCrezcamosService = inject( PerfilCrezcamosService );
  private diaService = inject( DialogService );
  private socketConexion = inject(SocketConexion);
  private ref = inject(DynamicDialogRef);

  async ngOnInit() {
    if ( !this.informacionPerfil ) {
      this.banMensaje = true;
      this.carInformacionInicial = false;
      return;
    }
    this.dataSolicitudes = this.informacionPerfil.perfilCrezcamosSolicitudesDTO;
    this.listSolicitudes = this.informacionPerfil.perfilCrezcamosSolicitudesDTO.solcitudesVigentesDTOS;
    this.conectarSocket();
    this.cargarFormularioEstados();
    this.rolUsuario = this.autServicio.obtenerRolesUsuarios();
    const [
      estDenegado,
      estCancelado,
      lisEstados,
      lisEstadoRol,
      permisos,
      perGestionar,
      perBloquear,
      estBloqueado,
      lisEstadosContact,
      lisCanalesEstados,
      alivio,
      cargarRolGes,
      apbdes, lisRolFuncionalidad, linkRetoma, sarlaftGestionDocumental, sarlaftGestionRiesgo
    ] =  await forkJoin (
      this.conConstanteServicio.getByCode('ESTDEN'),
      this.conConstanteServicio.getByCode('ESTCAN'),
      this.estServicio.listado(),
      this.estRolesServicio.listadoHabilitados(),
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GCOMERCIAL', 'LLAMADA', 'ESCUCHAR'),
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GCOMERCIAL', 'FLUVENTA', 'GESTIONAR'),
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GCOMERCIAL', 'FLUVENTA', 'BLOQSOL'),
      this.conConstanteServicio.getByCode('ESTBLO'),
      this.cenLlamadaEstadoServicio.listadoHabilitados(),
      this.conCanalEstadoServicio.listadoHabilitados(),
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GCOMERCIAL', 'RADALV', 'BTNRALV'),
      this.cargarPermisoFreelance(),
      this.conConstanteServicio.getByCode('APBDES'),
      this.rolFuncionalidadService.getAllByCodigoFuncionalidadYUsuario(Funcionalidades.COMITECREDITO, this.autServicio.obtenerIdUsuarioLogueado()),
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GCOMERCIAL', 'FLUVENTA', 'BTNGENLIN'),
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GDSARLAFT', 'SARLAFTGD', 'GEDOSA'),
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GRSARLAFT', 'SARLAFTGR', 'GERISA')
    ).toPromise();

    this.permisos.comite = !!lisRolFuncionalidad.find(x => !!x.indicadorInsertar);
    this.permisos.escuchar = !!permisos.find(x => !!this.autServicio.obtenerRolesUsuarios().find(y => x.codigoRol === y));
    this.permisos.gestionarFlujo = !!perGestionar.find(x => !!this.autServicio.obtenerRolesUsuarios().find(y => x.codigoRol === y));
    this.permisos.bloquear = !!perBloquear.find(x => !!this.autServicio.obtenerRolesUsuarios().find(y => x.codigoRol === y));
    this.permisos.alivio = !!alivio.find(x => !!this.autServicio.obtenerRolesUsuarios().find(y => x.codigoRol === y));
    this.permisos.linkRetoma = !!linkRetoma.find(x => !!this.autServicio.obtenerRolesUsuarios().find(y => x.codigoRol === y));
    this.permisos.sarlaftGestionDocumental = !!sarlaftGestionDocumental.find(x => !!this.autServicio.obtenerRolesUsuarios().find(y => x.codigoRol === y));
    this.permisos.sarlaftGestionRiesgo = !!sarlaftGestionRiesgo.find(x => !!this.autServicio.obtenerRolesUsuarios().find(y => x.codigoRol === y));
    this.estRoles = lisEstadoRol;
    this.lisCentroLlamadaEstados = lisEstadosContact;
    this.lisConfiguracionCanalEstados = lisCanalesEstados;
    this.constanteAPBDES = apbdes;

    if (estDenegado && estDenegado.valor) {
      const estDen = lisEstados.find(x => x.codigo == estDenegado.valor);
      if (estDen) {
        this.estDenegado = estDen;
      }
    }
    if (estCancelado && estCancelado.valor) {
      const estCan = lisEstados.find(x => x.codigo == estCancelado.valor);
      if (estCan) {
        this.estCancelado = estCan;
      }
    }

    if (estBloqueado && estBloqueado.valor) {
      const estBloq = lisEstados.find(x => x.codigo == estBloqueado.valor);
      if (estBloq) {
        this.estBloqueado = estBloq;
      }
    }

    const usuario = this.autServicio.obtenerUsuario();
    if ( usuario && usuario.idTercero ) {
      const [terCargo, oficinas, freelance] = await forkJoin(
         this.terCargosServicio.obtenerPorTercero( usuario.idTercero ),
         this.conConstanteServicio.getByCode('OFIPER'),
         this.cargarUsuarioComisionFreelance()
        ).toPromise();
      const ofi = (oficinas && oficinas.valor) ? oficinas.valor.split(',') : [];
      this.verFlujo = terCargo ? !ofi.find(x => x === terCargo.codigoEstructuraFisica) : true;
    }
    this.cargarTabla();
    this.carInformacionInicial = false;
  }

  conectarSocket() {
    this.socketConexion.socket.on('gestionSolicitud', (data) => {
      this.lisSolicitudSocket = data;
    });
    this.socketConexion.socket.emit('gestionSolicitud', {
      conectar: true
    });
  }

  async cargarTabla() {
    this.columnasSolicitudes = [
      { field: 'numeroCredito', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_NUMEROCREDITO/IDSOLICITUD'), sort: false },
      { field: 'estado', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_ESTADO'), sort: false },
      { field: 'oficina', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_OFICINA'), sort: false },
      { field: 'fechaCreacion', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_FECHACREACION'), sort: false },
      { field: 'monto', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_MONTO'), sort: false },
      { field: 'noCuotas', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_NUMEROCUOTAS'), sort: false },
      { field: 'amortizacion', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_AMORTIZACION'), sort: false },
      { field: 'destino', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_DESTINO'), sort: false },
      { field: 'ejecutivo', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_EJECUTIVO'), sort: false },
      { field: 'acciones', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_ACCIONES'), sort: false }
    ];
  }

  async cargarPermisoFreelance() {
    if (this.autServicio.obtenerNivelMaximo() === 5) {
      this.permisos.verFreelance = true;
      return;
    }
    const rolGes = await this.conConstanteServicio.getByCode('ROLGES').toPromise();
    if (!rolGes || !rolGes.valor) {
      return;
    }
    const roles = rolGes.valor.split(',');
    this.permisos.verFreelance = !!roles.find(x => !!this.autServicio.obtenerRolesUsuarios().find(y => y === x));
    return;
  }

  async obtenerItems(row: any, toogle: OverlayPanel, event: any) {
    this.idRegistroCargandoItems = row.idProspecto ? row.idProspecto : row.idProceso ? row.idProceso : row.idSolicitud;
    const restriccionGestionPorEstados = await this.verificarRestriccionGestionPorEstados(row);
    if (row.idPagaduria) {
      await this.validarRolLibranza(row);
    }
    this.lisItems = [];
    if (row.indicadorComite && this.permisos.comite) {
      this.lisItems.push({
        label: this.navServicio.buscarMensaje('GESTIONCOMERCIAL.BTN_VISUALIZARCOMITE'), icon: 'fa fa-eye', command: () => {
          this.verComite(row);
        }
      });
    }
    if (row && row.idSolicitud && row.indicadorBloqueadoSarlaft) {
      this.verDetalleSarlaft(row);
    }
    if (row && row.idSolicitud && row.indicadorBloqueadoSarlaft) {
      if ( this.permisos.sarlaftGestionRiesgo) {
        this.agregarItemLista('GESTIONCOMERCIAL.BTN_GESTIONAR', 'fa fa-pencil', () => this.continuarSarlaft(row, true));
      } else if ( this.permisos.sarlaftGestionDocumental) {
          this.agregarItemLista('GESTIONCOMERCIAL.BTN_GESTIONAR', 'fa fa-pencil', () => this.continuarSarlaft(row));
      }
    } else if (await this.validarSolicitud(row, restriccionGestionPorEstados)) {
        this.agregarItemLista('GESTIONCOMERCIAL.BTN_GESTIONAR', 'fa fa-pencil', () => this.continuar(row));
    }
    if (!this.validarSiTieneIndicadorFreelance(row) && !restriccionGestionPorEstados && row.idSolicitud && !row.indicadorEstadoFinal && !row.indicadorUCBloqueada && this.verRadicar(row) && !row.indicadorRestringido) {
      this.lisItems.push({
        label: this.navServicio.buscarMensaje('GESTIONCOMERCIAL.BTN_CANCELAR'), icon: 'fa fa-trash', command: () => {
          this.cancelar(row, BotonesSolicitud.CANCELAR);
        }
      });
    }
    if (!this.validarSiTieneIndicadorFreelance(row) && !restriccionGestionPorEstados && row.idSolicitud && !row.indicadorEstadoFinal && !row.indicadorUCBloqueada && this.verRadicar(row) && !row.indicadorRestringido) {
      this.lisItems.push({
        label: this.navServicio.buscarMensaje('GESTIONCOMERCIAL.BTN_DENEGAR'), icon: 'fa fa-times-circle', command: () => {
          this.denegar(row, BotonesSolicitud.DENEGAR);
        }
      });
    }
    this.idRegistroCargandoItems = null;
    toogle.toggle(event);
  }

  async verificarRestriccionGestionPorEstados(row: any) {
    if (row.indicadorRestriccionGestion) {
      const [rolCanales, lisCanalesRestriccionesGestionXEstados] =
        await forkJoin(
          this.canRolServicio.obtenerPorIdCanal(row.idCanal),
          this.canalRestriccionGestionEstadoService.obtenerPorCanalHabilitados(row.idCanal)
        ).toPromise();
      if (rolCanales.find(
        x => x.indicadorHabilitado &&
          x.codigoRol === this.rolUsuario.find(s => s === x.codigoRol))) {
        return false;
      } else {
        if (
          lisCanalesRestriccionesGestionXEstados.find(x => x.idEstado === row.idEstado)) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  async validarRolLibranza(row: any) {
    if (!this.constanteAPBDES) {
      return;
    }
    const listRoles = this.constanteAPBDES.valor.split(',');

    if (this.rolUsuario.find((x: any) => x === listRoles.find((y: any) => y === x)) && row.indicadorLibranza && row.indicadorAprobado) {
      this.libranza = true;
      return;
    } else {
      this.libranza = false;
    }
  }

  ver(data: any) {
    /* ver detalle del proceso */
    if (data.idProceso) {
      this.verDetallerProceso(data);
      return;
    }

    if (data.idProspecto) {
      this.router.navigate(['pys/gestion-comercial/prospecto/detalle/' + data.idProspecto]);
      this.ref.close();
      return;
    }

    if (!data.indicadorCreadoMovil) {
      this.router.navigate(['pys/gestion-comercial/detalle/' + data.idSolicitud + '/true']);
      this.ref.close();
      return;
    }

    this.router.navigate(['pys/gestion-comercial/perfilamiento/detalle/' + data.idSolicitud]);
    this.ref.close();
    return;
  }

  verDetallerProceso(row: any) {
    this.router.navigate(['pys/gestion-comercial/gestion-tercero/' + row.idProceso]);
    this.ref.close();
  }

  verComite(data: any) {
    this.router.navigate( [ 'pys/gestion-comercial/detalle-comite/' + data.idSolicitud + '/true' ] );
    this.ref.close();
  }

  verDetalleSarlaft(data: any) {
    if ( this.permisos.sarlaftGestionRiesgo) {
      this.lisItems.push({
        label: this.navServicio.buscarMensaje('BTN_VISUALIZARSARLAFT'), icon: 'fa fa-eye', command: () => {
          this.router.navigate(['pys/gestion-comercial/gestion-riesgo/detalle/' + data.idSolicitud + '/true']);
          this.ref.close();
        }
      });
    } else if (this.permisos.sarlaftGestionDocumental) {
      this.lisItems.push({
        label: this.navServicio.buscarMensaje('BTN_VISUALIZARSARLAFT'), icon: 'fa fa-eye', command: () => {
          this.router.navigate(['pys/gestion-comercial/gestion-documental/detalle/' + data.idSolicitud + '/true']);
          this.ref.close();
        }
      });
    }
  }

  verSolicitudCredito(row: any) {
    const mn = this.autServicio.obtenerFuncionalidades().find(x => x.ruta === 'sol/gestion-solicitud');
    if (!mn) {
      this.navServicio.setMesage(0, {
        severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('GESTIONCOMERCIAL.MSG_NOTIENEPERMISOS')
      });
      return;
    }
    this.router.navigate(['pys/gestion-comercial/solicitud-credito/' + row.idSolicitud]);
    this.ref.close();
  }

  agregarItemLista(labelKey: string, icon: string, command: any) {
    this.lisItems.push({
      label: this.navServicio.buscarMensaje(labelKey),
      icon: icon,
      command: command
    });
  }
 async validarSolicitud (row: any, restriccionGestionPorEstados: any) {
  return !this.validarSiTieneIndicadorFreelance(row) && !restriccionGestionPorEstados &&
    (!row.idPlataformaDigital || (row.idPlataformaDigital && row.indicadorAsignarEjecutivo)) &&
    (row.idSolicitud && !row.indicadorEstadoFinal && !row.indicadorBloqueado && (!row.indicadorCheckDocumental ||
      !row.indicadorCreadoMovil) && (row.indicadorCreadoMovil || !this.validarEstadoContact(row.idEstado)) &&
      this.verRadicar(row) && !row.indicadorRestringido && (!row.indicadorAlivios || this.permisos.alivio));
 }

 validarEstadoContact(idEstado: string) {
  return !!this.lisCentroLlamadaEstados.find(x => x.idEstado === idEstado);
 }

  async cargarUsuarioComisionFreelance() {
    const usuario = this.autServicio.obtenerUsuario();
    if (!usuario || this.autServicio.obtenerNivelMaximo() !== 1) {
      return;
    }
    this.usuarioComisionFreelance = await this.usuarioComisionFreelanceService.obtenerPorIdUsuario(usuario.idUsuario).toPromise();
  }

  validarSiTieneIndicadorFreelance(row: any) {
    if (!this.usuarioComisionFreelance || !row.idUsuarioComisionFreelance) {
      return false;
    }
    const usuario = this.autServicio.obtenerUsuario();
    if (this.usuarioComisionFreelance.idUsuarioComisionFreelance !== row.idUsuarioComisionFreelance ||
      (usuario.indicadorFreelance && this.usuarioComisionFreelance.indicadorHabilitado)) {
      return false;
    }
    return true;
  }

  cancelar(data: any, tipo: string) {
    this.validandoIndicador = true;
    this.solServicio.validarIndicadorDescargadoPorSolicitud(data.idSolicitud).subscribe(response => {
      if (!response || !response.estado) {
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_ADVERTENCIA'),
          detail: response ? response.mensaje : ''
        });
        this.validandoIndicador = false;
      } else {
        this.validandoIndicador = false;
        if (data.idProspecto) {
          this.conServicio.confirm({
            message: this.navServicio.buscarMensaje('GESTIONCOMERCIAL.MSG_CANCELARPROSPECTO'),
            header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
            icon: 'fa fa-question-circle',
            key: 'cancelar',
            accept: () => {
              this.buscando = true;
              this.proServicio.obtenerPorId(data.idProspecto).subscribe(prospecto => {
                prospecto.indicadorHabilitado = false;
                this.proServicio.actualizar(prospecto).subscribe(pros => {
                  this.buscando = false;
                  this.navServicio.setMesage(2);
                  this.refrescarPantalla();
                });
              });
            },
            reject: () => {
            }
          });
        } else {
          this.verModalCambioEstado(data, tipo, true);
        }
      }
    });
  }

  async verModalCambioEstado(solicitud: any, tipo: string, mostrarConfirmacion = true) {
    if (!mostrarConfirmacion) {
      this.verificarCambioEstado(solicitud, tipo);
    } else {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje(this.obtenerMensajeTipo(tipo).mensaje),
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        key: 'cancelar',
        accept: () => {
          this.verificarCambioEstado(solicitud, tipo);
        },
        reject: () => {
        }
      });
    }
  }

  verificarCambioEstado(solicitud: any, tipo: string) {
    if (solicitud.idProducto) {
      this.verificarCambioConProducto(solicitud, tipo);
    } else {
      this.verificarCambioSinProducto(solicitud, tipo);
    }
  }

  verificarCambioConProducto(solicitud: any, tipo: string) {
    this.buscando = true;
    const control = this.obtenerMensajeTipo(tipo);
    this.proEstadoRelacionServicio.listadoPorProductoYEstado(solicitud.idProducto, solicitud.idEstado).subscribe(listado => {
      const registro = listado.find(x => x.indicadorHabilitado && x.codigoFuncionalidadPadre === control.seccion && x.codigoFuncionalidadHijo === control.control);
      if (registro) {
        this.datCambioEstado.idEstado = registro.idEstado;
        this.datCambioEstado.idSolicitud = solicitud.idSolicitud;
        this.datCambioEstado.valZona = control.valZona;
        this.datCambioEstado.idFase = registro.indicadorMantieneFase ? solicitud.idFase : registro.idFase;
        this.datCambioEstado.tipo = tipo;
        this.datCambioEstado.titulo = control.titulo;
        this.datCambioEstado.mensajeGuardado = control.mensajeGuardado;
        this.proEstadoRelacionCausalServicio.listadoPorProductoEstadoRelacion(registro.idProductoEstadoRelacion).subscribe(lista => {
          this.cargarCausales(lista.map(s => ({ label: s.nombreCausal, value: s.idCausal })), control);
          this.cambioEstado.mosModal = true;
          this.buscando = false;
        });
      } else {
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('FLUJOPROCESO.MSG_ERRORCONFIGURACION')
        });
        this.buscando = false;
      }
    });
  }

  verificarCambioSinProducto(solicitud: any, tipo: string) {
    const control = this.obtenerMensajeTipo(tipo);
    if (control.idEstadoProducto) {
      this.buscando = true;
      this.datCambioEstado.idEstado = control.idEstadoProducto;
      this.datCambioEstado.idFase = solicitud.idFase;
      this.datCambioEstado.tipo = tipo;
      this.datCambioEstado.titulo = control.titulo;
      this.datCambioEstado.valZona = control.valZona;
      this.datCambioEstado.idSolicitud = solicitud.idSolicitud;
      this.datCambioEstado.mensajeGuardado = control.mensajeGuardado;
      this.estCausalService.listadoPorEstadoHabilitado(this.datCambioEstado.idEstado).subscribe(l => {
        this.cargarCausales(l.map(s => ({ label: s.causalSolicitud, value: s.idCausalSolicitud })), control);
        this.cambioEstado.mosModal = true;
        this.buscando = false;
      });
    } else {
      this.navServicio.setMesage(0, {
        severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('FLUJOPROCESO.MSG_ERRORCONFIGURACION')
      });
    }
  }

  cargarCausales(lista: SelectItem[], control: any) {
    if (lista.length > 1) {
      this.datCambioEstado.verCausal = true;
      this.cambioEstado.lisCausales = lista;
    } else if (lista.length === 1) {
      this.fEstados.causal.setValue(lista[0].label);
      this.fEstados.idCausal.setValue(lista[0].value);
      this.datCambioEstado.verCausal = true;
    } else {
      this.datCambioEstado.verCausal = control.causalObligatoria;
    }
    this.fEstados.idCausal.setValidators(this.datCambioEstado.verCausal ? [Validators.required] : []);
    this.fEstados.idCausal.updateValueAndValidity();
  }

  get fEstados() {
    return this.cambioEstado.formEstados.controls;
  }

  cargarFormularioEstados() {
    this.cambioEstado.formEstados = this.fb.group({
      idCausal: [null],
      causal: [null],
      observacion: [null]
    });
  }

  obtenerMensajeTipo(tipo: string) {
    const objeto = {
      mensaje: 'FLUJOPROCESO.MSG_CONFIRMARCAMBIOESTADO',
      control: '',
      seccion: 'DATA',
      idEstadoProducto: null,
      titulo: null,
      causalObligatoria: false,
      valZona: false,
      mensajeGuardado: null
    };
    switch (tipo) {
      case BotonesSolicitud.CANCELAR:
        objeto.titulo = 'SOLICITUD.LBL_CANCELAR';
        objeto.mensaje = 'FLUJOPROCESO.MSG_CONFIRMARCANCELAR';
        objeto.control = 'CANCELARWEB';
        objeto.idEstadoProducto = this.estCancelado ? this.estCancelado.idEstado : null;
        break;
      case BotonesSolicitud.DENEGAR:
        objeto.titulo = 'SOLICITUD.LBL_DENEGAR';
        objeto.mensaje = 'FLUJOPROCESO.MSG_CONFIRMARDENEGAR';
        objeto.control = 'DENEGARWEB';
        objeto.idEstadoProducto = this.estDenegado ? this.estDenegado.idEstado : null;
        break;
      case BotonesSolicitud.DETENER:
        objeto.seccion = 'FLUVEN';
        objeto.control = 'BLOQSOL';
        objeto.titulo = 'SOLICITUD.LBL_CAMBIODETENTER';
        objeto.mensajeGuardado = 'FLUJOPROCESO.MSG_SOLICITUDBLOQUEADA';
        objeto.idEstadoProducto = this.estBloqueado ? this.estBloqueado.idEstado : null;
        objeto.valZona = true;
        objeto.causalObligatoria = true;
        break;
      default:
    }
    return objeto;
  }

  denegar(data: any, tipo: string) {
    this.validandoIndicador = true;
    this.solServicio.validarIndicadorDescargadoPorSolicitud(data.idSolicitud).subscribe(response => {
      if (!response || !response.estado) {
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_ADVERTENCIA'),
          detail: response ? response.mensaje : ''
        });
        this.validandoIndicador = false;
      } else {
        this.validandoIndicador = false;
        this.verModalCambioEstado(data, tipo, true);
      }
    });
  }
  async continuarSarlaft(data: any, tipo: boolean = false) {
    const existe = this.lisSolicitudSocket.find(x => x.idSolicitud === data.idSolicitud);
    if (!!existe) {
      this.validandoIndicador = true;
      const mensajeSwalTerceroOcupado = {
        title: this.navServicio.buscarMensaje('MSG_GESTIONSOLICITUD'),
        html: await this.translateService.get('MSG_MENSAJEUSUARIOGESTION', {
          value: existe.usuario
        }).toPromise(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        imageUrl: '/assets/images/info.png',
        imageHeight: 64,
        confirmButtonText: this.navServicio.buscarMensaje('BTN_CERRAR'),
        preConfirm: () => {
        }
      };
      swal(mensajeSwalTerceroOcupado);
      this.validandoIndicador = false;
      return;
    }
    tipo ? this.router.navigate(['pys/gestion-comercial/gestion-riesgo/' + data.idSolicitud ]) : this.router.navigate(['pys/gestion-comercial/gestion-documental/' + data.idSolicitud ]);
    this.ref.close();
  }

  async continuar(data: any) {
    if (!this.permisos.gestionarFlujo) {
      this.navServicio.setMesage(0, {
        severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('GESTIONCOMERCIAL.MSG_NOTIENEPERMISOS')
      });
      return;
    }

    if (data.idProceso) {
      this.gestionarProceso(data);
      return;
    }

    if (!data.indicadorCreadoMovil && !data.indicadorComite && !data.indicadorCheckDocumental && data.idProducto && !this.validarCanalRol(data.idEstado, data.idCanal)) {
      this.navServicio.setMesage(0, {
        severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('GESTIONCOMERCIAL.MSG_NOEXISTECONFIGURACIONCANALROL')
      });
      return;
    }

    if (data.indicadorComite && !this.permisos.comite) {
      this.navServicio.setMesage(0, {
        severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('GESTIONCOMERCIAL.MSG_NOTIENEPERMISOSCOMITE')
      });
      return;
    }

    if (data.indicadorComite && !(await this.consultarFiltroAprobacion(data.idSolicitud))) {
      this.navServicio.setMesage(0, {
        severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: !this.consultarAprobacion.mensaje ? this.navServicio.buscarMensaje('GESTIONCOMERCIAL.MSG_NOSECUENTACONPERMISOS') : this.consultarAprobacion.mensaje
      });
      this.validandoIndicador = false;
      return;
    }

    const existe = this.lisSolicitudSocket.find(x => x.idSolicitud === data.idSolicitud);
    if (!!existe) {
      this.validandoIndicador = true;
      const mensajeSwalTerceroOcupado = {
        title: this.navServicio.buscarMensaje('MSG_GESTIONSOLICITUD'),
        html: await this.translateService.get('MSG_MENSAJEUSUARIOGESTION', {
          value: existe.usuario
        }).toPromise(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        imageUrl: '/assets/images/info.png',
        imageHeight: 64,
        confirmButtonText: this.navServicio.buscarMensaje('BTN_CERRAR'),
        preConfirm: () => {
        }
      };
      swal(mensajeSwalTerceroOcupado);
      this.validandoIndicador = false;
      return;
    }

    this.router.navigate([data.indicadorCreadoMovil ? ('pys/gestion-comercial/perfilamiento/informacion/' + data.idSolicitud) : (data.indicadorCheckDocumental ? ('pys/gestion-comercial/radicacion/' + data.idSolicitud + '/true') : (data.indicadorComite ? ('pys/gestion-comercial/gestor-comite-credito/' + data.idSolicitud) : ('pys/gestion-comercial/flujo-venta-proceso/editar/' + data.idSolicitud)))]);
    this.ref.close();
  }

  async consultarFiltroAprobacion(idSolicitud: String) {
    this.validandoIndicador = true;
    this.consultarAprobacion = await this.solServicio.consultarFiltroAprobacion(idSolicitud, false).toPromise();
    return this.consultarAprobacion.cumple
  }

  gestionarProceso(row: any) {
    this.router.navigate(['pys/gestion-comercial/flujo-venta-proceso/tercero/' + row.idTercero + '/' + row.idProceso]);
    this.ref.close();
  }

  validarCanalRol(idEstado: string, idCanal: string) {
    return !!this.lisConfiguracionCanalEstados.find(x => x.idEstado === idEstado && x.idCanal === idCanal);
  }

  verRadicar(data: any): boolean {
    return !!this.estRoles.find(x => x.idEstado === data.idEstado && !!this.rolUsuario.find(y => y === x.codigoRol));
  }
  mostrarMensajeBloqueoSolicitudZona() {
    this.navServicio.setMesage(0, {
      severity: 'info', summary: this.navServicio.buscarMensaje('LBL_ADVERTENCIA'),
      detail: this.navServicio.buscarMensaje('SOLICITUD.MSG_ERROREDITARZONASOLICITUD')
    });
  }

  async cambiarEstado() {
    const validarGestionSolicitud = await this.validarGestionando( this.datCambioEstado.idSolicitud );
    if ( !validarGestionSolicitud )
      return;
    this.cambioEstado.submitted = true;
    if (!this.cambioEstado.formEstados.valid) {
      return;
    }
    this.cambioEstado.guardando = true;
    if (this.datCambioEstado.valZona) {
      const estSolicitud = await this.fluProcesoService.validarZona(this.datCambioEstado.idSolicitud);
      if (!estSolicitud) {
        this.cambioEstado.guardando = false;
        return;
      }
    }
    const registro = this.cambioEstado.formEstados.value;
    this.solServicio.cambiarEstado(this.datCambioEstado.idSolicitud, this.datCambioEstado.idEstado, registro.idCausal, this.datCambioEstado.idFase, registro.observacion, false).subscribe(r => {
      this.navServicio.setMesage(0, {
        severity: 'success', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje(this.datCambioEstado.mensajeGuardado ? this.datCambioEstado.mensajeGuardado : 'FLUJOPROCESO.MSG_ESTADOMODIFICADO')
      });
      this.refrescarPantalla();
      this.cerrarModalEstados();
    }, error => {
      this.navServicio.setMesage(0, {
        severity: 'error', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('FLUJOPROCESO.MSG_ERRORCAMBIOESTADO')
      });
      this.cerrarModalEstados();
    });
  }

  async validarGestionando( idSolicitud ) {
    return new Promise( async resolve => {
      const existe = await this.notificadorService.obtenerSolicitud( idSolicitud ).toPromise();
      if ( existe && existe.idUsuario !== this.autServicio.obtenerIdUsuarioLogueado() ) {
        const mensajeSwalTerceroOcupado = {
          title: this.navServicio.buscarMensaje( 'MSG_GESTIONSOLICITUD' ),
          html: await this.translateService.get( 'MSG_MENSAJEUSUARIOGESTION', {
            value: existe.usuario
          } ).toPromise(),
          allowOutsideClick: false,
          allowEscapeKey: false,
          imageUrl: '/assets/images/info.png',
          imageHeight: 64,
          confirmButtonText: this.navServicio.buscarMensaje( 'BTN_CERRAR' ),
          preConfirm: () => {
            this.cerrarModalEstados();
          }
        };
        swal( mensajeSwalTerceroOcupado );
        resolve(false);
      } else {
        resolve(true);
      }
    } );
  }

  cerrarModalEstados() {
    this.cambioEstado.mosModal = false;
    this.cambioEstado.guardando = false;
    this.datCambioEstado = {
      tipo: null,
      idFase: null,
      idEstado: null,
      titulo: null,
      verCausal: false,
      idSolicitud: null,
      valZona: false,
      mensajeGuardado: null
    };
    this.cargarFormularioEstados();
    this.cambioEstado.submitted = false;
    this.cambioEstado.lisCausales = [];
    this.cambioEstado.formEstados.markAsPristine();
  }

  refrescarPantalla() {
    this.carInformacionInicial = true;
    this.dataSolicitudes = [];
    this.listSolicitudes = [];
    this.perfilCrezcamosService.relanzarSolicitudes (this.informacionPerfil.idTercero ).subscribe(
      res => {
        this.dataSolicitudes = res;
        this.listSolicitudes = res.solcitudesVigentesDTOS;
        this.carInformacionInicial = false;
      },
      error => {
        this.carInformacionInicial = false;
      }
    );
  }

  visualizarFirmantes( solicitud: any ) {
    const modal = this.diaService.open(PerfilCrezcamosModalFirmantesComponent, {
      header: this.navServicio.buscarMensaje( 'PERFILCREZCAMOS.LBL_FIRMANTESSOLICITUD' ),
      closeOnEscape: true,
      width: '70%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: false,
      data: {
        solicitud: solicitud
      }
    });
    modal.onClose.subscribe((data: any) => {
    });
  }
  formatCurrency(value: any): string {
    if (value < 0) {
      const separadorMiles = '.';
      let numero = Math.abs(value).toString();
      let resultado = '';

      if (numero.indexOf('.') !== -1) {
        numero = numero.split('.')[0];
      }

      for (let i = numero.length - 1, j = 0; i >= 0; i--, j++) {
        resultado = numero.charAt(i) + (j > 0 && j % 3 === 0 ? separadorMiles : '') + resultado;
      }

      if (value < 0) {
        resultado = '$-' + resultado;
      }

      return resultado;
    }
    if (value === 0) {
      return '$0';
    }
    if (value === null || value === '-') {
      return '-';
    }
    if (value < 1000) {
      return '$0.' + value.toLocaleString('en-US', {
        minimumIntegerDigits: 3,
        useGrouping: false
      }).replace(',', '.'); // Reemplaza coma con punto
    }
    return '$' + (value / 1000).toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).replace(',', '.'); // Reemplaza coma con punto
  }

}
